import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { IfYoutubeNativeStation } from './IfYoutubeNativeStation';
import { YoutubeBroadcastsListPage } from './YoutubeBroadcastsListPage';

/** Station-scoped entry for the YouTube broadcasts list page. */
export function YoutubeBroadcastsListStationPage() {
  return (
    <StationPageWrapper>
      <IfYoutubeNativeStation>
        <YoutubeBroadcastsListPage />
      </IfYoutubeNativeStation>
    </StationPageWrapper>
  );
}
